import { render, staticRenderFns } from "./DashboardAdhesions.vue?vue&type=template&id=bed8b444&"
import script from "./DashboardAdhesions.vue?vue&type=script&lang=js&"
export * from "./DashboardAdhesions.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdhesions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports